import React from "react";
import { Box } from "@mui/material";
import { useTheme } from '@mui/material/styles';

const EndpointContent = ({ method, path }) => {
    const theme = useTheme();
    return (
        <Box component='div' display={'flex'} flexDirection='row' alignItems='center' border='1px solid' borderColor='#3399bf' borderRadius={'4px'} marginBottom='1rem' style={{ whiteSpace: 'nowrap' }}>
            <Box padding={'4px'} bgcolor={'#f08d00'} width='4rem' textAlign={'center'} fontWeight='bold' fontSize={'1rem'} color='white' style={{ borderTopLeftRadius: '4px', borderBottomLeftRadius: '4px' }} >
                {method}
            </Box>
            <Box component='div' fontFamily={'bt_mono,Courier New,monospace'} color={theme.palette.mode === 'dark' ? '' : '#555'} fontSize={'.9375rem'} fontWeight='700' marginLeft={'0.5rem'} sx={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
                {path}
            </Box>
        </Box>
    )
}

export default EndpointContent;